import type { TestRunEvent } from '../types';

const KEY = 'iiq.workflow-builder.run-history.v1';
const MAX = 20;

export interface RunRecord {
  id: string;
  workflowId: string;
  workflowName: string;
  startedAt: number;
  finishedAt: number;
  events: TestRunEvent[];
  outcome: 'success' | 'partial' | 'failed';
  nodesFired: number;
  durationMs: number;
}

export function listRuns(): RunRecord[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    return JSON.parse(raw) as RunRecord[];
  } catch {
    return [];
  }
}

export function recordRun(run: RunRecord): void {
  const all = listRuns();
  all.unshift(run);
  while (all.length > MAX) all.pop();
  localStorage.setItem(KEY, JSON.stringify(all));
}

export function clearRuns(): void {
  localStorage.removeItem(KEY);
}

export function pruneByWorkflow(workflowId: string): void {
  const all = listRuns().filter(r => r.workflowId !== workflowId);
  localStorage.setItem(KEY, JSON.stringify(all));
}
